import React from 'react'
import { Container, Col, Row } from '@paypalcorp/pp-react'
import GithubIcon from '../../../../icons/githubIcon'
import data from '../../../../content/home/home.en-XC.yaml'

import './style.css'
import ProductOffering from './components/ProductOffering/index'

const Explore = () => {
  const { text, url, linkText } = data.content.explore.cta
  const { tiles } = data.content.explore || []

  const target = url.includes('github') ? '_blank' : '_self'

  return (
    <section className="explore">
      <Container>
        <Row>
          <Col className="floatCol">
            <h3 className="exploreHeader">Explore our APIs & SDKs</h3>
          </Col>
        </Row>
        <Row>
          <ProductOffering data={tiles} />
        </Row>
        <Row>
          <Col>
            <div className="alertBanner">
              <GithubIcon />
              <p className="alertBanner-txt">{text}</p>
              <a
                href={url}
                className="badgeLink"
                target={target}
                rel="noreferrer"
              >
                {linkText}
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Explore
